import { Box, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";

import { useContext, useEffect, useState } from "react";

import Star from "../../components/icons/Star";
import { purple } from "../../config";
import { WebsocketContext, IPlayer } from "../../contexts/websocketContext";

const LeaderBoard: React.FC<{ style?: React.CSSProperties }> = ({ style = {} }) => {
  const { leaderboard, players, myPlayer } = useContext(WebsocketContext);

  const [places, setPlaces] = useState<
    Array<{ names: Array<string>; score: number; isMine: boolean }>
  >([]);

  useEffect(() => {
    const newPlaces: Array<{ names: Array<string>; score: number; isMine: boolean }> = [];
    for (let place = 0; place < 3; place++) {
      if (leaderboard.length > place) {
        if (newPlaces[place] === undefined) {
          newPlaces[place] = { names: [], score: 0, isMine: false };
        }
        newPlaces[place].score = leaderboard[place].score;
        leaderboard[place].playerIds.forEach((playerId: string) => {
          const player: IPlayer | undefined = players.find(
            (player: IPlayer) => player.id === playerId
          );
          if (player !== undefined) {
            newPlaces[place].names.push(player.name);
            if (player.id === myPlayer.id) {
              newPlaces[place].isMine = true;
            }
          }
        });
      }
    }
    setPlaces(newPlaces);
  }, [leaderboard, myPlayer.id, players]);

  return (
    <Box width="100%" overflow="hidden" borderRadius={2}>
      {places.map((placeData, index) => (
        <Box
          width="100%"
          display="flex"
          bgcolor={placeData.isMine ? blue[400] : blue[700]}
          padding={1}
          alignItems="center"
        >
          <Box flex={1}>
            <Typography color={placeData.isMine ? purple[700] : "white"} variant="h6">
              {index + 1}
            </Typography>
          </Box>
          <Box flex={7} alignSelf="flex-start">
            <Typography color={placeData.isMine ? purple[700] : "white"} variant="h6">
              {placeData.names.join(", ")}
            </Typography>
          </Box>
          <Box flex={1} display="flex" alignItems="center">
            <Typography color={placeData.isMine ? purple[700] : "white"} variant="h6">
              {placeData.score}
            </Typography>{" "}
            <Star fontSize={"22px"} opacity={1} style={{ marginLeft: 8 }} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default LeaderBoard;
